<template>
  <mdb-container fluid class="gp-has-header">

    <data-table v-show="!showEditor" ref="storeList" :add-handler="create"
                :actions="actions"
                @handleAction="handleRowAction"
                add-label="New Page"
                queryName="SystemPage"
                page-title="System Pages/Text"
                title-icon="edit"
                show-add-button/>

    <editor-wizard v-if="showWizard" @cancel="showWizard=false" @pageGenerated="wizardDone" :prefill="wizardData"/>

    <div v-if="showEditor && !showWizard" class="text-left">
      <mdb-btn rounded size="sm" @click="showList">
        <mdb-icon icon="arrow-left"/>
        Back to List
      </mdb-btn>
      <mdb-btn rounded size="sm"
        :disabled="!currentPage.name || !currentPage.folder || !currentPage.pageText || !currentPage.sequence"
        @click="save" color="success">
        <mdb-icon icon="save"/>
        Save
      </mdb-btn>

      <mdb-card>
        <mdb-card-body>
          <mdb-row>
            <mdb-col md="6">
              <mdb-input id="documentTitle" v-model="currentPage.name" label="Document Title"/>
            </mdb-col>
            <mdb-col md="6">
              <label class="active">Folder</label>
              <select id="folder" v-model="currentPage.folder" class="browser-default gp-custom-select">
                <option v-for="folder in folders" :value="folder.value">{{ folder.text }}</option>
              </select>
            </mdb-col>

          </mdb-row>
          <mdb-row>
            <mdb-col md="6">
              <label class="active">Language</label>
              <select id="language" v-model="currentPage.language" class="browser-default gp-custom-select">
                <option v-for="lang in languages" :value="lang.value">{{ lang.text }}</option>
              </select>
            </mdb-col>

          </mdb-row>

          <mdb-row>
            <mdb-col md="6">
              <mdb-input id="seq" v-model="currentPage.sequence" label="Seq#" type="number"/>
            </mdb-col>
            <mdb-col
              v-if="currentPage.folder == 'ROOT' || currentPage.folder == 'Page-Help' || currentPage.folder=='Announcements' || currentPage.folder=='Legal' || currentPage.folder == 'Stand Alone' || currentPage.folder == 'Raw HTML'"
              md="6">
              <mdb-input id="urlName" v-model="currentPage.urlName" label="URL Name"/>
            </mdb-col>
          </mdb-row>
          <mdb-row v-if="currentPage.folder=='FAQ'">
            <mdb-col md="12">
              <mdb-input id="parent" v-model="currentPage.parent" label="FAQ Category"/>
            </mdb-col>
          </mdb-row>
          <mdb-row>
            <mdb-col md="6">
              <div class="md-form">
                <label class="active">Visibility</label>
                <select id="displayTo" v-model="currentPage.displayTo" class="browser-default gp-custom-select">
                  <option value="Public">Public</option>
                  <option value="User">Logged-in User</option>
                  <option value="Admin">Admin</option>
                </select>
              </div>
            </mdb-col>
            <mdb-col
              v-if="currentPage.folder != 'FAQ' && currentPage.folder != 'Email Text' && currentPage.folder != 'Raw HTML'
                && currentPage.displayTo != 'Public' && currentPage.folder != 'Stand Alone'"
              md="6">
              <div class="md-form">
                <label class="active">Location</label>
                <select id="location" v-model="currentPage.location" class="browser-default gp-custom-select">
                  <option value="FullTop">Full Top</option>
                  <option value="Left">Left</option>
                  <option value="Right">Right</option>
                </select>
              </div>
            </mdb-col>
          </mdb-row>
          <mdb-row v-if="currentPage.folder == 'home-page'">
            <mdb-col md="6">
              <div class="md-form">
                <div>
                  <datetime v-model="currentPage.startDate"
                            :auto="true"
                            :format="userDetails.dateFormat"
                            :valueZone="userDetails.timezone"
                            :week-start="userDetails.mondayFirst ? 1 : 7"
                            :zone="userDetails.timezone"></datetime>
                  <label class="active mr-5">Display From</label>
                  <mdb-btn rounded size="sm" @click="currentPage.startDate=null">Clear Date</mdb-btn>
                </div>
              </div>
            </mdb-col>
            <mdb-col md="6">
              <div class="md-form">
                <div>
                  <datetime v-model="currentPage.endDate"
                            :auto="true"
                            :format="userDetails.dateFormat"
                            :valueZone="userDetails.timezone"
                            :week-start="userDetails.mondayFirst ? 1 : 7"
                            :zone="userDetails.timezone"></datetime>
                  <label class="active mr-5">Display Through</label>
                  <mdb-btn rounded size="sm" @click="currentPage.endDate=null">Clear Date</mdb-btn>
                </div>
              </div>
            </mdb-col>
          </mdb-row>
          <mdb-row>
            <mdb-col v-if="currentPage.folder == 'home-page' && currentPage.displayTo == 'Public'"
                     md="6">
              <mdb-input id="topIcon" v-model="currentPage.topIcon" label="Top Icon"/>
              <div class="text-info m-4">Visit <a href="https://useiconic.com/open" target="_blank">useiconic.com</a>
                for
                possible icon names.
              </div>
            </mdb-col>
            <mdb-col
              v-if="currentPage.folder != 'FAQ' && currentPage.folder != 'Email Text' && currentPage.folder != 'home-page'
          && currentPage.folder != 'Legal' && currentPage.folder != 'Raw HTML'"
              md="6">
              <mdb-input id="discoverable" name="discoverable" v-model="currentPage.discoverable"
                         label="Include on FAQ Page"
                         type="checkbox"/>
            </mdb-col>
            <mdb-col
              v-if="currentPage.urlName && currentPage.displayTo == 'Public' && (currentPage.folder == 'Stand Alone' || currentPage.folder == 'Raw HTML')"
              md="6">
              <mdb-input id="addToSitemap" name="addToSitemap" v-model="currentPage.addToSitemap"
                         label="Include in Sitemap (SEO)"
                         type="checkbox"/>
            </mdb-col>
          </mdb-row>
          <div class="mb-4 border" v-if="currentPage.folder != 'Raw HTML'">
            <div class="formless-label">Document Body</div>
            <div id="text-wizard-area" class="grey lighten-5 border">
              <editor v-model="currentPage.pageText" :init="editorConfig"></editor>
            </div>
            <div class="gp-end-wrap">
              <mdb-btn icon="hat-wizard" rounded size="sm" @click="showWizard=true">Use Page Wizard</mdb-btn>
            </div>
          </div>
          <div class="mb-4 border" v-if="currentPage.folder == 'Raw HTML'">
            <!-- mdb-input v-model="currentPage.pageText" label="Raw HTML" type="textarea" rows="15"/> -->
            <ace-editor v-model="currentPage.pageText" @init="editorInit" lang="html" theme="chrome" width="100%"
                        height="750"></ace-editor>
            <mdb-btn icon="eye" rounded size="sm" @click="preview">Preview</mdb-btn>
          </div>
          <mdb-row>
            <mdb-col
              v-if="currentPage.urlName && currentPage.displayTo == 'Public' && (currentPage.folder == 'Stand Alone' || currentPage.folder == 'Raw HTML')"
              md="12">
              <div class="md-form">
                <mdb-input id="metaDescription" v-model="currentPage.metaDescription" type="textarea" :rows="3"
                           label="Meta Description "/>
              </div>
            </mdb-col>
          </mdb-row>

          <mdb-btn
            :disabled="!currentPage.name || !currentPage.folder || !currentPage.pageText || !currentPage.sequence"
            @click="save" color="success">
            <mdb-icon icon="save"/>
            Save
          </mdb-btn>

          <mdb-btn @click="showList">
            <mdb-icon icon="arrow-left"/>
            Back to List
          </mdb-btn>

        </mdb-card-body>
      </mdb-card>
    </div>

    <mdb-modal :show="cloneModal" @close="cloneModal = false">
      <mdb-modal-header class="secondary-color" :close="true" center>
        <h3>Clone Page</h3>
      </mdb-modal-header>
      <mdb-modal-body>
        <div>
          <mdb-input v-model="currentPage.name" placeholder="Page Name" label="Name"/>
        </div>
        <div>
          <label class="active">Language</label>
          <select id="language" v-model="currentPage.language" class="browser-default gp-custom-select">
            <option v-for="lang in languages" :value="lang.value">{{ lang.text }}</option>
          </select>
        </div>
      </mdb-modal-body>
      <mdb-footer>
        <mdb-btn icon="copy" @click="doClone" color="success">Clone</mdb-btn>
        <mdb-btn icon="times-circle" @click="cloneModal=false" color="warning">Cancel</mdb-btn>
      </mdb-footer>
    </mdb-modal>

    <mdb-modal :show="showImageSelector" @close="showImageSelector = false" class="gp-z-2000">
      <mdb-modal-header :close="true" center>Select an Image
      </mdb-modal-header>
      <mdb-modal-body>
        <image-selector emitOnSelection="imageSelected" @imageSelected="imageSelected"/>
      </mdb-modal-body>
    </mdb-modal>

    <mdb-modal v-if="previewHtml" size="lg" @close="previewHtml=null">
      <mdb-modal-header :close="true" center class="secondary-color">
        <h3>Preview</h3>
      </mdb-modal-header>
      <mdb-modal-body>
        <div v-html="previewHtml"/>
      </mdb-modal-body>
    </mdb-modal>

  </mdb-container>

</template>
<script>
import draggable from "vuedraggable"
import api from '../../services/groupsPlaceApi.js'
import error from '../common/Error'
import editor from '@tinymce/tinymce-vue'
import EditorWizard from "../common/EditorWizard";
import editorSettings from "../../services/editorSettings";
import ImageSelector from "../group/ImageSelector";
import dataTable from "../common/DataTableAdvanced";
import Vue from "vue";
import {Datetime} from 'vue-datetime'
import AceEditor from "vue2-ace-editor"

import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbCardImage,
  mdbCardText,
  mdbCardTitle,
  mdbCol,
  mdbContainer,
  mdbFileInput,
  mdbIcon,
  mdbInput,
  mdbMask,
  mdbModal,
  mdbModalBody,
  mdbModalFooter,
  mdbModalHeader,
  mdbRow,
  mdbTbl,
  mdbTblBody,
  mdbTblHead,
  mdbTooltip,
  mdbTreeview,
  mdbTreeviewItem,
  mdbView
} from 'mdbvue';

export default {
  name: "system-pages-admin",
  display: "Admin System Pages",
  order: 1,
  components: {
    mdbContainer,
    mdbBtn,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbCardImage,
    mdbMask,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbModalFooter,
    mdbIcon,
    mdbTreeview,
    mdbTreeviewItem,
    mdbBadge,
    mdbView,
    mdbTooltip,
    mdbInput,
    mdbFileInput,
    mdbTbl,
    mdbTblHead,
    mdbTblBody,
    draggable,
    error,
    editor,
    Datetime,
    dataTable,
    EditorWizard,
    ImageSelector,
    AceEditor
  },
  computed: {
    userDetails: function () {
      return this.$store.state.userDetails
    },
    settings: function () {
      return this.$store.state.settings
    },
    language: function () {
      return this.$store.state.language
    }
  },
  mounted() {
    this.editorConfig.file_picker_callback = this.myFileBrowser;
    this.editorConfig.paste_data_images = true;
    this.editorConfig.images_upload_handler = this.handlePastedImage;
    this.editorConfig.valid_elements = '*[*]';
    this.loadLanguages()
  },
  data() {
    return {
      pages: [],
      showConfirm: false,
      currentPage: {
        id: null, name: "", pageText: "", location: "FullTop", folder: "General", sequence: 100, urlName: null,
        startDate: null, endDate: null
      },
      showEditor: false,
      showViewer: false,
      imageCallback: null,
      showWizard: false,
      showImageSelector: false,
      wizardData: null,
      editorConfig: editorSettings.theWorksInline(),
      cloneModal: false,
      actions: [
        {name: "edit", label: "Edit", class: "text-success", icon: "pencil"},
        {name: "clone", label: "Clone", class: "text-warning", icon: "copy"},
        {name: "preview", label: "Preview", class: "text-secondary", icon: "browser"}
      ],

      folders: [
        {text: "None", value: "ROOT"},
        {text: "Announcements", value: "Announcements"},
        {text: "Email Text", value: "Email Text"},
        {text: "FAQ", value: "FAQ"},
        {text: "Features", value: "Features"},
        {text: "Home Page", value: "home-page"},
        {text: "Legal", value: "Legal"},
        {text: "Page Help", value: "Page-Help"},
        {text: "Raw HTML", value: "Raw HTML", selected: false},
        {text: "Stand Alone Page", value: "Stand Alone", selected: true}

      ],
      languages: null,
      previewHtml: null
    }
  },
  methods: {
    editorInit: function () {
      require('brace/ext/language_tools') //language extension prerequsite...
      require('brace/mode/html')
      require('brace/mode/javascript')    //language
      require('brace/mode/less')
      require('brace/theme/chrome')
      require('brace/theme/textmate')
      require('brace/ext/searchbox')
      require('brace/snippets/javascript') //snippet
    },
    preview() {
      this.previewHtml = "<div>" + this.currentPage.pageText + "</div>"
    },
    handlePastedImage: async function (blobInfo, success, failure, progress) {
      this.$store.dispatch("setExecuting", true)
      let results = await api.generalUploadImage("pasted", null, blobInfo.blob())

      if (results.success) {
        success(results.image.url)
        let els = document.getElementsByClassName("mce-content-body")
        if (els.length > 0) {
          let el = els[0]
          let images = el.getElementsByTagName("img")
          for (let i of images) {
            if (!i.hasAttribute("width")) {
              i.setAttribute("width", "33%");
              i.classList.add("gp-user-image-left");
            }
          }
        }
      }
      else {
        failure(error.response.data, {remove: true})
      }
      this.$store.dispatch("setExecuting", false)


    },
    wizardDone: function (result) {
      this.currentPage.pageText = result.html
      if (!this.currentPage.name) this.currentPage.name = result.header
      this.showWizard = false
      this.wizardData = result
      this.save()
    },
    create: function () {
      this.currentPage = {
        name: "", pageText: "", location: "FullTop", topIcon: null,
        sequence: 100, folder: "General", urlName: null, startDate: null, endDate: null,
        discoverable: false, displayTo: "Public", id: null, language: this.language
      }
      this.showEditor = true
      Vue.nextTick().then(() => {
        document.getElementById("documentTitle").focus()
      })

    },
    save: function () {
      this.$store.dispatch("setExecuting", true)

      api.post("/admin/page/", this.currentPage).then(
        (details) => {
          if (!this.currentPage.id) {
            //this.pages.unshift(details.data)
            this.currentPage = details.data
          }
          this.$notify.success({message: "Document saved successfully."})
        },
        (error) => {
          this.$notify.error({message: "Error saving document."})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    doClone: function () {
      this.$store.dispatch("setExecuting", true)

      api.post("/admin/clonePage/", this.currentPage).then(
        (details) => {
          this.cloneModal = false
          this.editPage(details.data)
          this.$store.dispatch("setDataTableReload", true)
        },
        (error) => {
          this.$notify.error({message: "Error saving document."})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    handleRowAction(row, action) {
      if (action == "edit") this.editPage(row)
      if (action == "clone") {
        this.currentPage = JSON.parse(JSON.stringify(row))
        this.cloneModal = true
      }
      if (action == "preview") {
        this.previewHtml = "<div>" + row.pageText + "</div>"
      }
    },
    editPage: function (page) {
      if (!this.languages) this.loadLanguages()
      this.$nextTick().then(() => {
        window.scrollTo(0, 0)
      })
      this.currentPage = page
      this.showEditor = true
    },
    loadLanguages() {
      this.languages = []
      for (let lang of this.settings.languages) {
        let text = `${lang.nativeName} (${lang.englishName})`
        if (lang.nativeName == lang.englishName) text = lang.nativeName
        let l = {text: text, value: lang.language}
        this.languages.push(l)
      }
    },
    uploadImage: function (img, success, failure) {
      let ret = {location: null}
      api.postImage("/admin/newImage/", img.blob()).then(
        (results) => {
          success(results.data)
        },
        (error) => {
          failure(error.response.data)
        });
    },
    showList: function () {
      this.showEditor = false
      this.$store.dispatch("setDataTableReload", true)
    },
    imageSelected: function (image) {
      this.showImageSelector = false
      let el = document.getElementsByClassName("tox-dialog-wrap")
      el[0].setAttribute("style", "display:block")
      Vue.nextTick().then(() => {
        this.imageCallback(image.url, {width: "33%", height: ""})
      })
    },
    myFileBrowser: function (callBack, value, meta) {
      let el = document.getElementsByClassName("tox-dialog-wrap")
      el[0].setAttribute("style", "display:none")
      Vue.nextTick().then(() => {
        this.showImageSelector = true
        this.imageCallback = callBack
      })
    }
  }

}
;
</script>
<style lang="scss">
@import '~vue-datetime/dist/vue-datetime.min';
</style>
